import { Grid } from 'theme-ui';
import CategoriesProductsCount from '@features/categories/components/CategoriesProductsCount/CategoriesProductsCount';
import styles from '@features/categories/components/CategoriesMobileBottomPanel/CategoriesMobileBottomPanel.styles';
import Button from '@components/Button/Button';
type PropsType = {
  productsCount?: number;
  leftButtonText: string;
  rightButtonText: string;
  position: 'vertical' | 'horizontal';
  handleLeftButtonClick: () => void;
  handleRightButtonClick: () => void;
};
const CategoriesFilterPanel = ({
  productsCount = 0,
  leftButtonText,
  rightButtonText,
  handleLeftButtonClick,
  position,
  handleRightButtonClick
}: PropsType) => <>
    {!!productsCount && <CategoriesProductsCount sx={styles.productsCount} align="center" productsLength={productsCount} />}
    <Grid columns={position === 'horizontal' ? 2 : 1} sx={{
    pt: '8px'
  }}>
      <div>
        <Button variant="outlined" variantColor="dark" size="small" fullWidth letterCase="uppercase" cy="LeftButton" onClick={handleLeftButtonClick}>
          {leftButtonText}
        </Button>
      </div>
      <div>
        <Button variant="default" variantColor="dark" size="small" fullWidth letterCase="uppercase" cy="RightButton" onClick={handleRightButtonClick}>
          {rightButtonText}
        </Button>
      </div>
    </Grid>
  </>;
export default CategoriesFilterPanel;